import { Injectable } from '@angular/core';

import { EntityStore, StoreConfig } from '@datorama/akita';

import { ResourceState } from './resource.state';

@Injectable({providedIn: 'root'})
@StoreConfig({name: 'resource', resettable: true, idKey: '_id'})
export class ResourceStore extends EntityStore<ResourceState> {
  constructor() {
    super() ;
  }
}
